import { api } from '../core';

export interface DocumentProviderAddNewUnassignedResponse {
  newProviderId: string;
}

interface DocumentProviderAddNewUnassignedProps {
  providerName: string;
  providerType: string; // 'TRUST' | 'GP' | 'HOSPITAL'; // (specified by user)
  documentIds: string[];
  unassignedDocumentIds: string[];
}

const documentProviderAddNewUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentProviderAddNewUnassigned: builder.query<
      DocumentProviderAddNewUnassignedResponse,
      DocumentProviderAddNewUnassignedProps
    >({
      query: ({
        providerName,
        providerType,
        documentIds,
        unassignedDocumentIds
      }: DocumentProviderAddNewUnassignedProps) => ({
        url: `document/provider/add/new/unassigned`,
        method: 'POST',
        body: {
          provider_name: providerName,
          provider_type: providerType,
          documentIds: documentIds,
          unassignedDocumentIds: unassignedDocumentIds
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Error in postDocumentProviderAddNewUnassigned in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentProviderAddNewUnassignedQuery } = documentProviderAddNewUnassignedApi;
